import React from 'react'
import Header from '../../components/shared/Header'
import Footer from '../../components/shared/Footer'
import Glossary from '../../images/Glossary (6).png'
function VerificationValidation() {

   const carbonData = [

    {
      title: "Verification:",
      description: "The independent and systematic examination of greenhouse gas emission reductions or removals claimed by a project to ensure their accuracy, completeness, and compliance with established standards or methodologies."
    },
    {
      title: "Validation:",
      description: "The process of assessing and confirming that a proposed project or program is in accordance with predefined criteria, methodologies, and standards, often conducted by an independent third party."
    },
    {
      title: "Validator:",
      description: "An individual or organization responsible for conducting the validation process, ensuring that a project meets the specified requirements and is eligible for carbon credits or other environmental certifications."
    },
    {
      title: "Verifier:",
      description: "An independent entity responsible for conducting the verification process to confirm the accuracy of reported greenhouse gas emission reductions or removals, typically after a project has been implemented."
    },
    {
      title: "Third-Party regulatory bodies:",
      description: "External organizations or agencies independent of businesses or industries, responsible for overseeing and enforcing regulations, standards, and compliance in various sectors. In the context of carbon credits, third-party regulatory bodies may validate and verify emission reduction projects."
    }
  ];


  const CarbonItem = ({ title, description }) => {
  return (
    <div className="flex flex-col items-start p-0 gap-4 w-full max-w-[1152px]">
      <h3 className="text-[24px] font-medium text-2xl leading-[29px] text-[#141414]">
        {title}
      </h3>
      <p className="w-full  font-normal text-[16px] leading-[150%] text-[#141414]">
        {description}
      </p>
    </div>
  );
};
  return (
    <>
    <Header/>
    <div className="relative w-full max-w-[1440px] h-[933px] top-[0px] mx-auto">
      {/* Text Section */}
      <div className="absolute w-full max-w-[1200px] h-[76px] left-1/2 transform -translate-x-1/2 top-[82px] flex flex-col items-center p-0 gap-10">
        <h1 className="w-full max-w-[688px] h-[76px] font-medium text-6xl leading-[76px] text-center text-[#141414]">
          Verification & Validation 
        </h1>
      </div>

      {/* Image Section */}
      <img 
        className="absolute w-full max-w-[1200px] h-[552px] left-1/2 transform -translate-x-1/2 top-[275px] rounded-2xl  object-fill"
        src={Glossary}
        alt="Carbon Incentive"
      />
    </div>


 <div className="w-full max-w-[1200px] mx-auto mt-20 mb-20 flex flex-col items-start gap-8">
      <h2 className=" font-bold text-[32px] leading-[38px] text-[#0D924F]">
        Verification & Validation 
      </h2>
      <div className="flex flex-col gap-6 w-full">
        {carbonData.map((item, index) => (
          <CarbonItem 
            key={index}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
    <Footer/>
    </>



  )
}

export default VerificationValidation




